import {MAKE_SAFE_CALL} from './../actions/safeCall';

const initialState = {
    make_safe_call_waiting : false,
    make_safe_call_success : {},
    make_safe_call_error :{},
}

export default function safeCall(state = initialState, action){
    switch (action.type){
        case MAKE_SAFE_CALL:
            return {
                ...state,
                make_safe_call_waiting : action.make_safe_call_waiting,
                make_safe_call_success : action.make_safe_call_response,
                make_safe_call_error : action.make_safe_call_error
            }
        default:
            return state;
    }
}